import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { DropInput } from "./downInput";

// Funkcja konwertująca RRULE na zrozumiały tekst
const rruleToText = (rrule) => {
    if (!rrule) return "Jednorazowe";

    const parts = Object.fromEntries(
        rrule.split(";").map(p => p.split("="))
    );

    let text = "";

    if (parts.FREQ === "DAILY") {
        text = `Codziennie (co ${parts.INTERVAL || 1} dni)`;
    }

    if (parts.FREQ === "WEEKLY") {
        const daysMap = {
            MO: "Poniedziałek",
            TU: "Wtorek",
            WE: "Środa",
            TH: "Czwartek",
            FR: "Piątek",
            SA: "Sobota",
            SU: "Niedziela"
        };
        const day = daysMap[parts.BYDAY] || "";
        text = `Co ${parts.INTERVAL || 1} tyg. (${day})`;
    }

    if (parts.FREQ === "MONTHLY") {
        const daysMap = {
            MO: "Poniedziałek",
            TU: "Wtorek",
            WE: "Środa",
            TH: "Czwartek",
            FR: "Piątek",
            SA: "Sobota",
            SU: "Niedziela"
        };
        const day = daysMap[parts.BYDAY?.slice(-2)] || "";
        text = `Co ${parts.INTERVAL || 1} mies. (${day})`;
    }

    return text;
};


const Container = styled.div`
  max-width: 500px;
  margin: 30px auto;
  padding: 20px;
  border-radius: 10px;
  background: #f9f9f9;
  box-shadow: 0 3px 8px rgba(0,0,0,0.1);
  font-family: sans-serif;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;
  color: #333;
`;

const Field = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  text-align: left;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border-radius: 5px;
  border: 1px solid #ccc;
  text-indent: 8px;
`;

const Select = styled.select`
  width: 100%;
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #ccc;
`;

const Button = styled.button`
  background-color: #007bff;
  color: white;
  padding: 10px 0;
  width: 100%;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;

  &:hover {
    background-color: #0069d9;
  }
`;

const EventList = styled.ul`
  margin-top: 20px;
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const EventCard = styled.li`
  background: #fff;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const EventInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DeleteButton = styled.button`
  background-color: #dc3545;
  color: #fff;
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #c82333;
  }
`;

const weekdays = [
    { value: "MO", label: "Monday" },
    { value: "TU", label: "Tuesday" },
    { value: "WE", label: "Wednesday" },
    { value: "TH", label: "Thursday" },
    { value: "FR", label: "Friday" },
    { value: "SA", label: "Saturday" },
    { value: "SU", label: "Sunday" },
];
const roczniki = [
    { rocznik: "2005", trener: "Jan Nowak" },
    { rocznik: "2006", trener: "Marek Kowalski" },
    { rocznik: "2007", trener: "Piotr Wiśniewski" },
    { rocznik: "2008", trener: "Andrzej Wójcik" },
    { rocznik: "2009", trener: "Krzysztof Zieliński" },
    { rocznik: "2010", trener: "Tomasz Kamiński" }
];

export default function EventCreator() {
    const [summary, setSummary] = useState("");
    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    const [date, setDate] = useState(formattedToday);
    const [frequency, setFrequency] = useState("WEEKLY");
    const [interval, setInterval] = useState(1);
    const [byDay, setByDay] = useState("MO");
    const [type, setType] = useState("training");
    const [events, setEvents] = useState([]);
    const [selectedRocznik, setSelectedRocznik] = useState(0);
    const [recurrenceType, setRecurrenceType] = useState("repeat"); // nowy stan

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await fetch(`https://api.pth-hokej.pl/api/eventsRocznik?rocznik=${selectedRocznik}`);
                if (!response.ok) throw new Error("Błąd przy pobieraniu wydarzeń");
                const data = await response.json();
                setEvents(data);
            } catch (err) {
                console.error(err);
            }
        };
        if (selectedRocznik) {
            fetchEvents();
        }
    }, [selectedRocznik]);

    const deleteEvent = async (id) => {
        try {
            const res = await fetch(`https://api.pth-hokej.pl/api/events/${id}`, {
                method: "DELETE",
            });
            if (!res.ok) throw new Error("Błąd przy usuwaniu wydarzenia");

            setEvents(events.filter((e) => e._id !== id));
        } catch (err) {
            console.error(err);
            alert("Nie udało się usunąć wydarzenia!");
        }
    };

    const addEvent = async () => {
        if (!date || !selectedRocznik) return;

        const dtstart = new Date(date);
        let rrule = null;

        if (recurrenceType === "repeat") {
            rrule = `FREQ=${frequency};INTERVAL=${interval}`;
            if (frequency === "WEEKLY") {
                rrule += `;BYDAY=${byDay}`;
            } else if (frequency === "MONTHLY") {
                rrule += `;BYDAY=1${byDay}`;
            }
        }

        const newEvent = { summary, dtstart, rrule, type, rocznik: selectedRocznik };

        try {
            const res = await fetch("https://api.pth-hokej.pl/api/events", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(newEvent),
            });

            if (!res.ok) throw new Error("Błąd przy zapisie wydarzenia");

            const savedEvent = await res.json();
            setEvents([...events, savedEvent]);

            // reset form
            setSummary("");
            setDate(formattedToday);
            setFrequency("WEEKLY");
            setInterval(1);
            setByDay("MO");
            setType("training");
            setSelectedRocznik(0);
            setRecurrenceType("repeat");

        } catch (err) {
            console.error(err);
            alert("Nie udało się zapisać wydarzenia!");
        }
    };

    return (
        <Container>
            <Title>Kreator wydarzeń</Title>

            <DropInput nazwa="Nazwa wydarzenia" value={summary} onChange={(e) => setSummary(e.target.value)} />

            <Field>
                <Label>Zespół</Label>
                <Select
                    value={selectedRocznik}
                    onChange={(e) => setSelectedRocznik(e.target.value)}
                >
                    <option value="">Wybierz rocznik</option>
                    {roczniki.map((rocznik, idx) => (
                        <option key={idx} value={rocznik.rocznik}>
                            {rocznik.rocznik} - {rocznik.trener}
                        </option>
                    ))}
                </Select>
            </Field>

            <Field>
                <Label>Typ wydarzenia</Label>
                <Select value={type} onChange={(e) => setType(e.target.value)}>
                    <option value="training">Trening</option>
                    <option value="game">Mecz / sparing</option>
                </Select>
            </Field>

            <DropInput nazwa="Data rozpoczęcia" type="date" value={date} onChange={(e) => setDate(e.target.value)} />

            <Field>
                <Label>Tryb wydarzenia</Label>
                <Select value={recurrenceType} onChange={(e) => setRecurrenceType(e.target.value)}>
                    <option value="once">Jednorazowe</option>
                    <option value="repeat">Cykliczne</option>
                </Select>
            </Field>

            {recurrenceType === "repeat" && (
                <>
                    <Field>
                        <Label>Częstotliwość</Label>
                        <Select value={frequency} onChange={(e) => setFrequency(e.target.value)}>
                            <option value="DAILY">Codziennie</option>
                            <option value="WEEKLY">Co tydzień</option>
                            <option value="MONTHLY">Co miesiąc</option>
                        </Select>
                    </Field>

                    <Field>
                        <Label>Interwał</Label>
                        <Input type="number" min={1} value={interval} onChange={(e) => setInterval(e.target.value)} />
                    </Field>

                    {frequency !== "DAILY" && (
                        <Field>
                            <Label>Dzień tygodnia</Label>
                            <Select value={byDay} onChange={(e) => setByDay(e.target.value)}>
                                {weekdays.map((day) => (
                                    <option key={day.value} value={day.value}>{day.label}</option>
                                ))}
                            </Select>
                        </Field>
                    )}
                </>
            )}

            <Button onClick={addEvent}>Dodaj wydarzenie</Button>

            <EventList>
                {events.map((e) => {
                    const eventDate = new Date(e.dtstart);

                    return (
                        <EventCard key={e._id}>
                            <EventInfo>
                                <strong>{e.summary}</strong>
                                <span>Typ: {e.type === "training" ? "Trening" : "Mecz"}</span>
                                <span>Start: {eventDate.toLocaleDateString("pl-PL")}</span>
                                <span>Powtarzanie: {rruleToText(e.rrule)}</span>
                            </EventInfo>
                            <DeleteButton onClick={() => deleteEvent(e._id)}>Usuń</DeleteButton>
                        </EventCard>
                    );
                })}
            </EventList>
        </Container>
    );
}
